module.exports = __webpack_public_path__ + "static/media/cheddar.5b639110.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/brand-logos/cheddar.png
// module id = 81
// module chunks = 0